import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaDiscord,
} from "react-icons/fa";

const SocialMediaDropdown = () => {
  const links = [
    {
      url: "https://www.facebook.com/IdcIndiaOfficial/",
      icon: <FaFacebookF size={30} />,
      color: "#1877F2",
    },
    {
      url: "https://www.linkedin.com/company/idcindiaofficial/",
      icon: <FaLinkedin size={30} />,
      color: "#0077B5",
    },
    {
      url: "https://x.com/idcindiaofficial",
      icon: <FaTwitter size={30} />,
      color: "#1DA1F2",
    },
    {
      url: "https://www.youtube.com/@idcindia.",
      icon: <FaYoutube size={30} />,
      color: "#FF0000",
    },
    {
      url: "https://discord.gg/EMC4KdUv",
      icon: <FaDiscord size={30} />,
      color: "#5865F2",
    },
  ];

  return (
    <div className="fixed bottom-[4.4rem] left-[1rem] z-50">
      <motion.div
        className=" p-4 rounded-xl  space-y-3 w-52"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        {links.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 transition-all transform hover:scale-105 hover:opacity-90"
            style={{ color: link.color }}
          >
            {link.icon}
            <span className="text-sm font-medium">{link.label}</span>
          </a>
        ))}
      </motion.div>
    </div>
  );
};

export default SocialMediaDropdown;
